export enum MatchOutcome {
  Tie = 1,
  Win = 2,
  Loss = 3,
  DidNotFinish = 4,
}
